const ChatHighlights = ({ sub_id }) => {
  const subId = sub_id || 0;
  {
    subId === 24 && (
      <div className="box-degrade p-4 mt-5">
        <div className="container-fluid text-center">
          <div className="row justify-content-center">
            <div className="col-12">
              <h4 className="text-uppercase">
                <strong>
                  Com base nas suas respostas, vamos indicar soluções
                  específicas para:
                </strong>
              </h4>
            </div>
          </div>
          <div className="row justify-content-center my-4">
            <div className="col px-3">
              <h4 className="text-uppercase">
                <strong>Digestão</strong>
              </h4>
              <p>Enzimas, HCL, sais biliares, mucosa gástrica</p>
            </div>
            <div className="col px-3 border-start border-end border-1 border-dark">
              <h4 className="text-uppercase">
                <strong>Intestino</strong>
              </h4>
              <p>
                Equilíbrio do microbioma com probióticos e fitonutracêuticos
              </p>
            </div>
            <div className="col px-3">
              <h4 className="text-uppercase">
                <strong>Inflamação e sensibilidade alimentar</strong>
              </h4>
              <p>Tolerância, leaky gut, modulação imune</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  {
    subId === 22 && (
      <div className="box-degrade p-4 mt-5">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <p>
                Com base nas suas respostas,{" "}
                <strong>
                  indicaremos soluções naturais que respeitam seu ciclo
                  circadiano
                </strong>{" "}
                — como magnésio de alta absorção, GABA natural,
                fitonutracêuticos calmantes, entre outros recursos clinicamente
                validados e de ação suave, porém efetiva -{" "}
                <strong>sem efeitos colaterais</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  {
    subId === 21 && (
      <div className="box-degrade p-4 mt-5">
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <p>
                Com base nessas respostas, seu plano pode incluir adaptógenos de{" "}
                <strong>ação ansiolítica</strong>, nootrópicos leves para{" "}
                <strong>foco e clareza</strong>, compostos naturais para{" "}
                <strong>regulação do humor</strong> e ativos clínicos como
                Rhodiola, Panax Ginseng, Ansiless, Zembrin, Saffrin, entre
                outros.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default ChatHighlights;
// This component is used to display small boxes with specific content based on the current section meta.
